import React from 'react'
import { useEffect } from 'react'
import Typography from '../../components/common/Typography'
import { useTrans } from '../../services/i18n'
import connect from './connect'
import Loader from '../../components/common/Loader'
import SpacingContainerBase from '../../components/layouts/SpacingContainerBase'
import { useNavigate } from 'react-router-dom'
import GovernmentResources from './components/governmentResources'
import FederalAgencyResources from './components/federalAgencyResources'

const ResourceLinks = ({
  pendingFeatures,
  authUser,
}) => {
  const { trans } = useTrans()
  const navigate = useNavigate()

  useEffect(() => {
    if (
      authUser &&
      (authUser.role === 'manager' || authUser.role == 'consulting')
    ) {
      navigate('/organizations')
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authUser])

  return (
    <SpacingContainerBase>
      {pendingFeatures && <Loader open={pendingFeatures} />}
      <Typography weight="600" variant="h2" fontFamily="lexend" title>
        {trans('resource-links')}
      </Typography>
      {!pendingFeatures && (
        <>
          <GovernmentResources />
          <FederalAgencyResources />
        </>
      )}
    </SpacingContainerBase>
  )
}

export default connect(ResourceLinks)